import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import StarBorder from '@mui/icons-material/StarBorder';
import Collapse from '@mui/material/Collapse';
import BusinessIcon from '@mui/icons-material/Business';
import HomeIcon from '@mui/icons-material/Home';
import PolicyIcon from '@mui/icons-material/Policy';
import useStyles from "./styles";
import { pathOr } from "ramda";

export default function DashboardSidebar({ menus=[],setValue,value,setLeftSideBar,leftSideBar }) {
  const classes = useStyles();
  const [openMenu, setOpenMenu] = useState({['Home']:true});
  const [parentMenu, setParentMenu] = useState([]);
  const [childMenu, setChildMenu] = useState([]);
    const [activeMenu,setActiveMenu]=useState(pathOr([], [ value], menus));
    const [AppType,setAppType]=useState('Home');
    // console.log("activeMenu",leftSideBar)
  useEffect(() => {
    const pMenu = [...new Set(menus.map(item => item.parentMenuName))];
    const cMenu = [];

    // Added By Deep K On 12-01-2022 to show the dashboard base on AppType ==> Replace Home By AppType state
    const TypeObj = {'GT' : 'Goal Tracker', 'IPR': 'Home'};
    const getAppType = localStorage.getItem('AppType');
    setAppType(TypeObj[getAppType != ''?getAppType:'IPR']);
    
    pMenu.map((menu) => {
      if(AppType !== menu && getAppType != ''){
        return;
      }
      const mName = menu || 'Home';
      cMenu[mName]=Object.values(menus).filter(element => mName==='Home'?element => !element.parentMenuName || element.parentMenuName==='Home' || element.parentMenuName==='': element.parentMenuName === menu);
      setOpenMenu({ ...openMenu, [mName]: mName===AppType?true:false })
    })
 
    setChildMenu({ ...cMenu })
  }, [menus])
  useEffect(()=>{
    setActiveMenu(pathOr([], [ value], menus));
  },[value])
  // console.log("openMenu",openMenu)
  const handleClickMenu = (menu) => {
    setOpenMenu({ ...openMenu, [menu]: !openMenu[menu] });
  };
  const handleChildClickMenu =(pageTitle) =>{
  
    let titleIndex=Object.values(menus).findIndex(element => element.pageTitle === pageTitle);
    setValue(titleIndex);
    // toggleDrawer('left', false);
    setActiveMenu(menus[titleIndex]);
    setLeftSideBar({ ...leftSideBar, ['left']: false });
    
  }


  // const [state, setState] = React.useState({
  //   top: false,
  //   left: false,
  //   bottom: false,
  //   right: false,
  // });

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setLeftSideBar({ ...leftSideBar, [anchor]: open });
  };
  const makeid=()=> {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  
    for (var i = 0; i < 5; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
  
    return text;
  }
  
  const list = (anchor) => (
    <Box
    key={makeid()}
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
      role="presentation"
    // onClick={toggleDrawer(anchor, false)}
    // onKeyDown={toggleDrawer(anchor, false)}
    >
      <List key={makeid()} className={classes.sideBarList}>
        {Object.keys(childMenu).map((pName, index) => (

          // <div key={makeid()}>          
          //   <ListItem key={makeid()} className={!activeMenu.parentMenuName && pName==='Home' || activeMenu.parentMenuName===pName?classes.activeMenu:classes.parentMenu} onClick={() => handleClickMenu(pName)}>
          //   <ListItemIcon key={makeid()}>
          //     {pName === 'Home' ? <HomeIcon key={makeid()} className={classes.activeIcon}/> : <BusinessIcon key={makeid()} className={classes.activeIcon}/>}
          //   </ListItemIcon>
          //   <ListItemText key={makeid()} primary={pName === 'Home' ? 'IPR' : pName} />
          //   {openMenu[pName] ? <ExpandLess key={makeid()} /> : <ExpandMore key={makeid()} />}
          // </ListItem>
          //   <Collapse in={openMenu[pName]} key={makeid()} timeout="auto" unmountOnExit>
          //     <List component="div" disablePadding>
          //       {Object.values(childMenu[pName]).map((cName, cIndex) => (
          //         cName['parentMenuName'] === pName || !cName['parentMenuName'] ?
          //           <ListItem sx={{ pl: 4 }} key={makeid()} className={activeMenu.pageTitle===cName['pageTitle']?classes.activeChildMenu:''} onClick={() => handleChildClickMenu(cName['pageTitle'])}>
          //             <ListItemIcon key={makeid()}>
          //               <PolicyIcon key={makeid()} className={activeMenu.pageTitle===cName['pageTitle']?classes.activeIcon:''}/>
          //             </ListItemIcon>
          //             <ListItemText key={makeid()} primary={cName['pageTitle']} />
          //           </ListItem> : null
          //       ))}
          //     </List>
          //   </Collapse>
          // </div>

          <div key={makeid()}>          
            <ListItem key={makeid()} className={!activeMenu.parentMenuName && pName===AppType || activeMenu.parentMenuName===pName?classes.activeMenu:classes.parentMenu} onClick={() => handleClickMenu(pName)}>
            <ListItemIcon key={makeid()}>
              {pName === AppType ? <HomeIcon key={makeid()} className={classes.activeIcon}/> : <BusinessIcon key={makeid()} className={classes.activeIcon}/>}
            </ListItemIcon>
            <ListItemText key={makeid()} primary={pName === 'Home' ? 'IPR' : pName} />
            {openMenu[pName] ? <ExpandLess key={makeid()} /> : <ExpandMore key={makeid()} />}
          </ListItem>
            <Collapse in={openMenu[pName]} key={makeid()} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {Object.values(childMenu[pName]).map((cName, cIndex) => (
                  cName['parentMenuName'] === pName || !cName['parentMenuName'] ?
                    <ListItem sx={{ pl: 4 }} key={makeid()} className={activeMenu.pageTitle===cName['pageTitle']?classes.activeChildMenu:''} onClick={() => handleChildClickMenu(cName['pageTitle'])}>
                      <ListItemIcon key={makeid()}>
                        <PolicyIcon key={makeid()} className={activeMenu.pageTitle===cName['pageTitle']?classes.activeIcon:''}/>
                      </ListItemIcon>
                      <ListItemText key={makeid()} primary={cName['pageTitle']} />
                    </ListItem> : null
                ))}
              </List>
            </Collapse>
          </div>
        ))}

      </List>
      <Divider />

    </Box>
  );

  return (
    <div>

      <React.Fragment key={"left"}>
        <IconButton
          className={classes.navIconButton}
          // color="default"
          aria-label="open drawer"
          onClick={toggleDrawer("left", true)}
          edge="start"
          sx={{ mr: 2, ...(leftSideBar['left'] && { display: 'none' }) }}
        >
          <MenuIcon />
        </IconButton>
        <Drawer
        key={makeid()}
          anchor={"left"}
          open={leftSideBar["left"]}
          onClose={toggleDrawer("left", false)}
        >
          {list("left")}
        </Drawer>
      </React.Fragment>
    </div>
  );
}
